import { useSearchParams } from "react-router-dom";

const LISTS = ["status", "category", "insee"];
const BOOLS = ["is_new", "is_modified", "weak", "contradiction"];

export const useUrlFilters = () => {
  const [sp, setSp] = useSearchParams();
  const f = {};
  sp.forEach((v, k) => {
    if (LISTS.includes(k)) f[k] = sp.getAll(k);
    else if (BOOLS.includes(k)) f[k] = v === "1";
    else f[k] = v;
  });
  const write = (next) => {
    const out = new URLSearchParams();
    Object.entries(next).forEach(([k, v]) => {
      if (v === undefined || v === null || v === "" || v === false) return;
      if (Array.isArray(v)) v.forEach((x) => out.append(k, x));
      else out.set(k, v === true ? "1" : v);
    });
    setSp(out, { replace: true });
  };
  const set = (patch) => write({ ...f, page: "", ...patch });
  const toggleList = (k, v) => {
    const cur = f[k] || [];
    set({ [k]: cur.includes(v) ? cur.filter((x) => x !== v) : [...cur, v] });
  };
  const reset = () => setSp(new URLSearchParams(), { replace: true });
  return { f, set, toggleList, reset };
};
